// Jim Lehmann Daily Motivation
// Deterministic quote per day (365) attributed to Jim Lehmann. No network calls.

const FRAG_A = [
  'Start where you stand', 'Small steps, big gains', 'Consistency compounds',
  'Effort beats excuses', 'Discipline is momentum', 'Make progress, not perfection',
  'Your future self is watching', 'Win the day', 'Form first, speed later',
  'Your only rival is yesterday', 'Stack tiny wins', 'Confidence follows action',
  'Intensity fades, habits stay', 'Less talk, more reps', 'Own your pace',
  'Show up for you', 'Do hard things', 'Strong is built daily',
  'Action cures doubt', 'Repeat the right things'
]

const FRAG_B = [
  'one clean rep at a time', 'with honest range', 'through the sticking point',
  'with controlled cadence', 'even on off days', 'with quiet confidence',
  'when no one is watching', 'with patience and grit', 'with full attention',
  'without cutting corners', 'through discomfort', 'with steady breath',
  'aligned with your goals', 'with eyes on the process', 'with grace under pressure',
  'and calibrate as you go', 'with posture and pride', 'with trust in the work',
  'with lids down and focus', 'brick by brick'
]

const FRAG_C = [
  'Build the body that builds your life.', 'Today sets the tone.', 'Let effort write the story.',
  'Stack days. See change.', 'You don’t need perfect—just present.', 'What you repeat, you become.',
  'Make count what counts.', 'Be your own standard.', 'Earn the feeling.',
  'Anchor the habit.', 'Process over outcome.', 'Quiet the noise. Train.',
  'Consistency is kindness to your future self.', 'Less friction, more action.', 'Finish stronger than you started.',
  'Win the next minute.', 'Respect the reps.', 'Stay in the pocket.',
  'Depth with intent. Always.', 'You’re closer than you think.'
]

// 20x20x20 -> 8000 unique combos; we pick 365 deterministically by date index

function dayOfYear(d = new Date()) {
  const start = new Date(d.getFullYear(), 0, 0)
  const diff = (d.getTime() - start.getTime()) + (start.getTimezoneOffset() - d.getTimezoneOffset()) * 60000
  return Math.floor(diff / 86400000) // 1..365
}

export function dailyMotivation(date = new Date()) {
  const idx = (dayOfYear(date) - 1) % 365
  // mix indices so quotes vary across the year
  const a = FRAG_A[(idx * 7) % FRAG_A.length]
  const b = FRAG_B[(idx * 11) % FRAG_B.length]
  const c = FRAG_C[(idx * 13) % FRAG_C.length]
  const text = `${a}, ${b}. ${c}`
  const author = 'Jim Lehmann'
  return { text, author }
}
